function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("rect", {
  x: 3.2,
  y: 5.6,
  width: 18.4,
  height: 1.6,
  rx: .8,
  fill: "currentColor"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.2 11.68a.8.8 0 0 1 .8-.8h16.8a.8.8 0 0 1 0 1.6H4a.8.8 0 0 1-.8-.8z",
  fill: "currentColor"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 3.2,
  y: 16,
  width: 18.4,
  height: 1.6,
  rx: .8,
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/menu.7a1a6d23.svg";
export { SvgComponent as ReactComponent };